import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C3E50',      // Steel Blue
      light: '#34495E',     // Slate Gray
      dark: '#1B2631',      // Darker Steel
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#16A085',      // Teal
      light: '#48C9B0',     // Light Teal
      dark: '#138D75',      // Dark Teal
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#E67E22',      // Engineering Orange
    },
    background: {
      default: '#FAFAFA',   // Paper White
      paper: '#FFFFFF',     // Pure White
    },
    text: {
      primary: '#2C3E50',   // Dark Steel
      secondary: '#7F8C8D', // Gray
    },
    divider: '#ECF0F1',     // Light Gray
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Roboto Mono", monospace',
      fontWeight: 700,
      fontSize: '2.5rem',
      color: '#2C3E50',
    },
    h2: {
      fontFamily: '"Roboto Mono", monospace',
      fontWeight: 600,
      fontSize: '2rem',
      color: '#2C3E50',
    },
    h3: {
      fontFamily: '"Roboto Mono", monospace',
      fontWeight: 500,
      fontSize: '1.5rem',
      color: '#2C3E50',
    },
    body1: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#2C3E50',
    },
    body2: {
      fontFamily: '"Inter", sans-serif',
      fontSize: '0.875rem',      // 14px - Slightly smaller than body1 (16px)
      lineHeight: 1.5,
      color: '#7F8C8D',          // Secondary gray color
    },
    button: {
      fontFamily: '"Inter", sans-serif',
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 0, // Sharp corners throughout
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'cta' },
          style: {
            backgroundColor: '#FF6B35',
            color: 'white',
            border: '2px solid #FF6B35',
            boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#E55A2B',
              borderColor: '#E55A2B',
              boxShadow: '0 6px 16px rgba(255, 107, 53, 0.4)',
              transform: 'translateY(-2px)'
            },
            transition: 'all 0.3s ease'
          }
        }
      ]
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          border: '2px solid #ECF0F1',
          boxShadow: '0 2px 8px rgba(44, 62, 80, 0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          border: '1px solid #ECF0F1',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
            fontFamily: '"Inter", sans-serif',
            '& fieldset': {
              borderWidth: '2px',
            },
            '&:hover fieldset': {
              borderWidth: '2px',
            },
            '&.Mui-focused fieldset': {
              borderWidth: '2px',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#2C3E50',
          boxShadow: '0 2px 8px rgba(44, 62, 80, 0.1)',
          borderBottom: '2px solid #ECF0F1',
        },
      },
    },
  },
});

export default theme;